import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, SavingsContainer, TextInput } from "../../components";

export default function CompanyCarbonImpact() {
  const [companysize, setCompanySize] = useState(5);

  const location = useLocation();
  const queryparams = new URLSearchParams(location.search);
  const { savings, frequency } = Object.fromEntries(queryparams.entries());
  const yearlySavings =
    (52 * parseFloat(savings) * parseFloat(frequency) * companysize) / 1000;
  if (!savings || !frequency) {
    return (
      <div>
        <p>Page not found!</p>
      </div>
    );
  }

  return (
    <div className="flex flex-1 h-[80vh] place-items-center p-16 gap-8">
      <div className="flex flex-col gap-4 w-1/2 ">
        <p className="font-semibold">Company-wide CO2 savings</p>
        <p className="font-bold text-5xl">
          Make a greater impact, spread the word.
        </p>
        <div className="flex flex-col gap-4">
          <p>
            Enter your company’s size to see how much CO2 you can save by
            encouraging carpooling. (We will use your stats as a baseline)
          </p>
          <div className="flex gap-4 place-items-center">
            {/* <p className="border p-2 rounded-lg py-2 px-4 w-[100px] text-center"> */}
            <input
              type="number"
              max={100000}
              value={companysize}
              onChange={(e) => setCompanySize(parseInt(e.target.value))}
              className="border p-2 rounded-lg py-2 px-4 w-[110px] text-center"
            />
            {/* {companysize.toLocaleString()}+ */}
            {/* </p> */}
            <input
              type="range"
              className="cursor-pointer w-2/3 h-1 appearance-none bg-gray-500"
              min={0}
              max={100000}
              value={companysize}
              onChange={(e) => setCompanySize(parseInt(e.target.value))}
              style={{
                accentColor: "black",
              }}
            />
          </div>
          <p>
            Share this simulator with your sustainability manager or HR manager
            to get them onboard. You’ll get €50 off for your referral!
          </p>
        </div>
        <div className="flex flex-col gap-6 w-4/5">
          <TextInput title="Name" required />
          <TextInput title="Company email" required />
          <Button title="Share the simulator!" />
        </div>
      </div>
      <div className="flex w-1/2 h-fit">
        <div className="grid grid-cols-1 gap-8 w-full">
          <SavingsContainer
            title="Yearly Fuel Savings"
            savings={10000}
            unit="Litres"
          />
          <SavingsContainer
            title="Yearly CO2 Savings"
            savings={yearlySavings}
            unit="tons of CO2"
          />
        </div>
      </div>
    </div>
  );
}
